const prefix = "ESTIMATOR_TEMPLATE_";

export const EDIT_GET = prefix + "EDIT_GET";
export const EDIT_SAVE = prefix + "EDIT_SAVE";
export const EXPORT_JSON = prefix + "EXPORT_JSON";
export const EXPORT_SPREADSHEET = prefix + "EXPORT_SPREADSHEET";
export const LIST = prefix + "LIST";
